// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3rlIA","legacyBtn":"MutateMid_legacyBtn__GIRq_"};